const SHARE_LABELS = {
  he: { ingredients: 'מצרכים', method: 'אופן הכנה' },
  en: { ingredients: 'Ingredients', method: 'Instructions' },
};

// Utility to generate share text for a recipe
export function getRecipeShareText(recipe, lang = 'en') {
  if (!recipe) return '';
  const labels = SHARE_LABELS[lang] ?? SHARE_LABELS.en;
  let text = `${recipe.title || ''}`;
  if (recipe.description) text += `\n${recipe.description}`;
  if (recipe.ingredients?.length) {
    text += `\n\n${labels.ingredients}:`;
    for (const ing of recipe.ingredients) {
      text += `\n- ${ing.name || ''}${ing.amount ? `: ${ing.amount}` : ''}`;
    }
  }
  if (recipe.steps?.length) {
    text += `\n\n${labels.method}:`;
    recipe.steps.forEach((s, i) => {
      text += `\n${i + 1}. ${s.instruction || ''}`;
    });
  }
  return text;
}
